import { lazy } from "react";

export class RouteChunkError extends Error {
  readonly cause: unknown;
  constructor(cause: unknown) {
    super("The page could not be downloaded. Reload to get the latest version.");
    this.cause = cause;
    this.name = "RouteChunkError";
  }
}

function isChunkFailure(error: unknown): boolean {
  return error instanceof Error &&
    /chunk.*(?:failed|error)|(?:failed|error).*chunk|failed to fetch dynamically imported module|importing a module script failed|failed to load module script|unable to preload css/i.test(error.message);
}

/** Retry a transient download once; keep application render/module errors intact.
 * Never reload automatically: another mounted surface may contain unsaved work. */
export const lazyRoute: typeof lazy = (load) => lazy(async () => {
  try {
    return await load();
  } catch (error) {
    if (!isChunkFailure(error)) throw error;
    try {
      return await load();
    } catch (retryError) {
      if (!isChunkFailure(retryError)) throw retryError;
      throw new RouteChunkError(retryError);
    }
  }
});
